module.exports = __webpack_public_path__ + "img/appltCourse-img7.f058d90d.png";